
class PlayerJoin {
    
    getType() {
        return 'player_join'
    }
    
    getData() {
        return {}
    }
    
}

export default PlayerJoin
